import * as React from 'react';
import {
  deleteWaterfallSchemas,
  editWaterfallSchemas,
  getFinancicalSchemas,
  addWaterfallSchemas,
  setFinSchemaError,
  newFinStrCreatingStatus
} from '../../../../store/actions';
import {connect} from 'react-redux';
import {preCreatingAddValues, preCreatingEditValues} from "../helpers";
import {validationCheck} from "../../../helpers";

class CustomIconsAgGrid extends React.Component {

  onDelete = (id) => {
    const {deleteWaterfallSchemas, getFinancicalSchemas, params} = this.props;
    const prom = deleteWaterfallSchemas(id);

    prom.then(() => {
      params.agGridReact.props.isOpenTabIndexChange(-1, false);
      getFinancicalSchemas();
    })
  };


  onEdit = (id) => {
    const {params, finSchemaErrors, getFinancicalSchemas, editWaterfallSchemas} = this.props;
    const reslut = preCreatingEditValues(params.data, params.colDef.finStrData);
    console.log(reslut);
    if (!validationCheck(finSchemaErrors)) {
      editWaterfallSchemas(reslut, id).then(() => {
        params.agGridReact.props.isOpenTabIndexChange(-1, false);
        getFinancicalSchemas();
      })
    }
  };

  onAdd = () => {
    const {params, finSchemaErrors, getFinancicalSchemas, addWaterfallSchemas, setFinSchemaError, newFinStrCreatingStatus} = this.props;
    const result = preCreatingAddValues(params.data,
      params.colDef.finStrData.waterfall_items_details,
      params.colDef.finStrName,
      setFinSchemaError);
    if (result.errorsExist) {
      params.api.redrawRows();
    } else {
      if (!validationCheck(finSchemaErrors)) {
        addWaterfallSchemas(result.result).then(() => {
          params.agGridReact.props.isOpenTabIndexChange(-1, false);
          newFinStrCreatingStatus(false);
          getFinancicalSchemas();
        })
      }
    }

  };

  render() {
    const {params} = this.props;

    return params.id > -1 ? (
        <div>
          <i
            className="btn-delete fa fa-trash fa-lg "
            onClick={() => this.onDelete(params.id)}
          />
          <i
            className="btn-edit fa fa-pencil fa-lg"
            onClick={() => this.onEdit(params.id)}
          />
        </div>
      ) :
      (
        <div>
          <i
            className="btn-add fa fa-save fa-lg "
            onClick={() => this.onAdd()}
          />
        </div>
      )
  }
}

const mapStateToProps = state => {
  return {
    finSchemaErrors: state.financicalSchemas.finSchemaErrors,
  }
};

export default connect(mapStateToProps, {
  deleteWaterfallSchemas,
  editWaterfallSchemas,
  getFinancicalSchemas,
  addWaterfallSchemas,
  setFinSchemaError,
  newFinStrCreatingStatus
})(CustomIconsAgGrid);


// WEBPACK FOOTER //
// ./src/views/FinancicalStructure/FinancicalStructure/FieldRenderer/CustomIconsAgGrid.js